module.exports = __webpack_public_path__ + "static/media/angular.a8390908.png";